export default {
    location: false,
    street_name: '',
    street_number: '',
    neighborhood: '',
    postal_code: '',
    city: '',
    uf: '',
    country: '',
    latitude: '',
    longitude: '',
    user_id: null
}
  